<template>
  <div class="type-card" :class="{isChecked:isChecked,disabled}" v-show="typeId" @click="handleClick">
    <div class="type-card-title">{{this.title}}</div>
    <div class="type-card-desc">{{this.desc}}</div>
  </div>
</template>
<script>
export default {
  name: "typeCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    typeId: {
      type: String,
      default: ""
    },
    isChecked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if(this.disabled){
        return
      }
      this.$emit("choose", "identity", this.typeId);
    }
  }
};
</script>
<style lang="scss" scoped>
.type-card {
  background: #fff;
  padding: 0.48rem 1rem 0.48rem 0.32rem;
  margin-bottom: 0.2rem;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    border: 0;
    right: 0.4rem;
    top: 50%;
    width: 0.32rem;
    height: 0.32rem;
    background: url("../../images/selected-no@3x.png") no-repeat;
    background-size: 100%;
    transform: translateY(-50%);
  }
  &.isChecked {
    &::after {
      // content: "";
      // position: absolute;
      // border-bottom: 2px solid #ff7226;
      // border-right: 2px solid #ff7226;
      // width: 0.14rem;
      // height: 0.22rem;
      // right: 0.4rem;
      // top: 50%;
      // transform: translateY(-50%) rotate(45deg);
      // width: 0.32rem;
      // height: 0.32rem;
      background: url("../../images/selected@3x.png") no-repeat;
      background-size: 100%;
    }
  }
  &.disabled{
    &::after{
      background:none;
    }
    .type-card-title,.type-card-desc{
      color: #ccc;
    }
  }
  .type-card-title {
    font-size: 0.4rem;
    margin-bottom: 0.1rem;
    color: #414141;
    font-weight: 500;
  }
  .type-card-desc {
    font-size: 0.28rem;
    color: #949494;
    line-height: 0.34rem;
  }
}
</style>


